import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private errorSubject = new BehaviorSubject<{ message: string; logId: string | null, code?: string } | null>(null);

  error$ = this.errorSubject.asObservable();

  showError( message: string, logId: string | null = null, code: string | null = null ) {
    this.errorSubject.next({ message, logId, code });
  }

  clearError() {
    this.errorSubject.next(null);
  }
}
